import styled from 'styled-components';
import tw from 'twin.macro';

const Editor = styled.div`
  position: relative;

  & {
    ${tw`w-full p-4 mb-8 sm:mb-4 border border-light-gray rounded-lg`}
  }
  background: ${(props) => props.bgColor || 'white'};

  & > div:first-child > div:first-child {
    ${tw`-mx-2`}
  }

  // div:first-child:not(.wrapper):not(.header) {
  //   border: none;
  //   padding: 0;
  //   margin: 0;
  //   background: ${(props) => props.bgColor || 'white'};
  // }

  .toolbar {
    div {
      background: transparent !important;
      margin-right: 8px !important;
    }
  }

  button:not(.btn) {
    border: none;
    background: transparent;
  }

  .DraftEditor-editorContainer {
    font-family: 'Montserrat', sans-serif;
    font-size: 15px;
    line-height: 20px;

    & > div:first-child {
      min-height: 100px;
    }

    div {
      margin: 0;
    }

    a {
      color: blue;
      text-decoration: underline;
    }
  }

  .video-script {
    width: 100%;
    background: #eee;
  }

  .upload-media {
    width: 28px;
    height: 30px;
    padding: 3px;
    position: absolute;
    top: 16px;
    left: 281px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  @media only screen and (max-width: 639px) {
    .submit-btn {
      position: fixed;
      top: 9px;
      right: 16px;
      z-index: 1001;
    }

    .editor {
      ${tw`rounded-none bg-gray-800 w-screen h-screen`}
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1002;

      .header {
        background: white;
        padding: 8px 16px;
        box-shadow: 0px 3px 6px #0000001a;
      }

      .DraftEditor-editorContainer {
        & > div:first-child {
          min-height: 200px;
          max-height: 200px;
        }
      }
    }

    .complete-btn {
      width: 100%;
      min-width: 100% !important;
      display: flex;
      align-items: center;
    }
  }
`;

export default Editor;
